import {
  GET_BALANCE_HISTORY_REQUEST,
  GET_BALANCE_HISTORY_SUCCESS,
  GET_BALANCE_HISTORY_FAILURE
} from 'Store/constants';

const initialState = {
  data: {
    bonusBalance: 0,
    histories: [],
    moneyBalance: 0,
    totalElements: 0,
    totalPages: 0
  },
  pageNumber: 0,
  pageSize: 20,
  isLoading: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_BALANCE_HISTORY_REQUEST:
      return { ...state, isLoading: true, error: null };
    
    case GET_BALANCE_HISTORY_SUCCESS:
      if (action.pageNumber === 0) {
        return {
          ...state,
          data: action.payload,
          pageNumber: action.pageNumber,
          isLoading: false,
          error: null,
        };
      } else {
        return {
          ...state,
          data: {
            ...action.payload,
            histories: [...state.data.histories, ...action.payload.histories]
          },
          pageNumber: action.pageNumber,
          isLoading: false,
          error: null,
        };
      }

    
    case GET_BALANCE_HISTORY_FAILURE:
      return { ...initialState, isLoading: false, error: action.payload };
    
    default:
      return state;
  }
};
